// Choose Campaign Takeover

const getChooseCampaignTakeoverState = (state: Record<string, any>) =>
  state.experiments.chooseCampaign;

export const getIsChooseCampaignTakeoverOpen = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).isDrawerOpen;

export const getChooseCampaignTableInfo = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).info;

export const getChooseCampaignTableCampaigns = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).campaigns;

export const getChooseCampaignTableLoading = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).loading;

export const getChooseCampaignSearch = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).search;

export const getChooseCampaignSortBy = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).sortBy;

export const getChooseCampaignSortDirection = (state: Record<string, any>) =>
  getChooseCampaignTakeoverState(state).sortDirection;
